import NoiseReport from './NoiseReport'
import { RedLineReport } from './RedLineReport'
import { SmokeQualityReport } from './SmokeQualityReport'

export default function ReportModal({ instance, property, onClose }) {
  if (instance) {
    const { eventClass, propertySmokingReportVersion } = instance
    const smokingReportVersion =
      property?.smokingReportVersion ?? propertySmokingReportVersion
    if (eventClass === 'SMOKE') {
      if (smokingReportVersion === 'RED_LINE') {
        return <RedLineReport eventId={instance.id} onClose={onClose} />
      }
      return <SmokeQualityReport event={instance} onClose={onClose} />
    }
    if (eventClass === 'NOISE') {
      return <NoiseReport instance={instance} onClose={onClose} />
    }
  }
  return null
}
